import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm, alert } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, RAFUnitOfWork } from 'src/app/core/core.module';
import { PurchaseOrderLine } from 'src/app/core/data/entities';
import { PurchaseOrderLineDialogComponent } from 'src/app/jobs/purchase-order-line-dialog/purchase-order-line-dialog.component';

@Component({
    selector: 'app-purchase-order-lines-search',
    templateUrl: './purchase-order-lines-search.component.html',
    styleUrls: ['./purchase-order-lines-search.component.scss'],
    standalone: false
})
export class PurchaseOrderLinesSearchComponent implements OnInit {
    purchaseOrderLines: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(private appInfo: AppInformationService, private modalService: BsModalService, private router: Router, private uow: RAFUnitOfWork) {}

    async ngOnInit(): Promise<void> {
        await this.getData();
    }

    async getData() {
        this.purchaseOrderLines = (await this.uow.getPurchaseOrderLines()) as PurchaseOrderLine[];
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    }
                },
                location: 'after'
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    }
                },
                location: 'after'
            }
        );
    }

    selectionChange(e) {}
    rowPrepare(e) {}

    rowDoubleClick(e) {
        this.open(e.data.jobId);
    }

    open(id?: number) {
        if (id == null) return;
        this.router.navigate(['/jobs/' + id]);
    }

    async addPurchaseOrder(purchaseOrderLine?: any) {
        const modalRef = this.modalService.show(PurchaseOrderLineDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                purchaseOrderLine: purchaseOrderLine
            }
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }

    async delete(row) {
        if (row === null) return;

        const result = await (confirm('Are you sure you want to DELETE this purchase order?', `${this.appInfo.settings.company}`) as Promise<boolean>);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        row.deleted = new Date();
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
